import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";

const Audit = () => {
    const screenId="Audit"
    const formatters = Formatters()
    const charts = {
        balance_adjustments_all : {
            specialFormatters: {
                owner_id : formatters.account_id_link,
                user_id : formatters.account_id_link,
                transaction_gps_datetime: formatters.isoDateTime,
                billing_amount: formatters.currency
            }
        },
        balance_adjustments_unloads : {
            specialFormatters: {
                owner_id : formatters.account_id_link,
                user_id : formatters.account_id_link,
                transaction_gps_datetime: formatters.isoDateTime,
                billing_amount: formatters.currency
            }
        },
        cards_going_negative_in_month : {
            specialFormatters : {
                card_id: formatters.card_id_link,
                neg_cards: formatters.int,
                num_actives: formatters.int
            }
        },
        cards_with_negative_balance : {
            specialFormatters : {
                card_id: formatters.card_id_link
            }
        },
        admin_accounts : {
            source:"live",
        },
        spends_in_4_active_transaction_days : {},
        spends_in_96_hours : {},
        sof_over_a_time_period: {
            source:"live",
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default Audit
